import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';
import { notify } from '../../../common/functions/react-toastify.function';

export const uploadPoRingsDetailExcel = async (poId, file) => {
  try {
    const formData = new FormData();
    formData.append('file', file);

    const response = await apiClient.post(
      `adminInvoiceManagement/purchaseOrderManagement/${poId}/rings-detail/upload`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );

    if (response.status === 200 || response.status === 201) {
      return {
        success: true,
        data: response.data?.response || response.data || [],
        message: response.data?.message || 'Rings detail uploaded successfully',
      };
    }
    const errorMessage = response.data?.error || 'Failed to upload file';
    notify('error', errorMessage);
    return { success: false, error: errorMessage };
  } catch (error) {
    const errorMessage = error.response?.data?.error || error.message || 'Failed to upload file';
    handleApiError(error);
    notify('error', errorMessage);
    return { success: false, error: errorMessage };
  }
};
